import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type NFTFilters } from '@pkg/types';

interface State {
    availableFilters?: NFTFilters;
    filteredResultsCount?: number;
    selectedFilters?: string[];
}
interface Actions {
    addSelectedFilter: (newFilter: string) => void;
    clearFilters: () => void;
    removeSelectedFilter: (filter: string) => void;
    setAvailableFilters: (availableFilters: State['availableFilters']) => void;
    setFilteredResultsCount: (filteredResultsCount: State['filteredResultsCount']) => void;
}

type NFTsFiltersStoreState = Actions & State;

const initialState: State = {
    filteredResultsCount: undefined,
    availableFilters: undefined,
    selectedFilters: undefined,
};

export const useNFTsFiltersStore = create<NFTsFiltersStoreState>()(
    devtools((set) => ({
        ...initialState,
        addSelectedFilter: (newFilter) =>
            set((state) => {
                let filters = state.selectedFilters || [];
                if (!filters?.includes(newFilter)) {
                    filters = [...filters, newFilter];
                }
                return { selectedFilters: filters };
            }),
        removeSelectedFilter: (filter) =>
            set((state) => {
                const filters = state.selectedFilters?.filter((f) => f !== filter);
                return { selectedFilters: filters };
            }),
        setAvailableFilters: (availableFilters) => set({ availableFilters }),
        setFilteredResultsCount: (filteredResultsCount) => set({ filteredResultsCount }),
        clearFilters: () => set({ selectedFilters: undefined }),
    })),
);
